// utils/seoHelper.js
// ✅ Use this in EVERY page component for dynamic SEO

export const updatePageSEO = ({ title, description, keywords, canonicalPath = "" }) => {
  // Title
  document.title = title;

  // Helper to set meta tag
  const setMeta = (selector, value, attribute = "content") => {
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement("meta");
      const [attr, val] = selector.replace("[", "").replace("]", "").split("=");
      el.setAttribute(attr.trim(), val.replace(/"/g, "").trim());
      document.head.appendChild(el);
    }
    el.setAttribute(attribute, value);
  };

  setMeta('meta[name="description"]', description);
  setMeta('meta[name="keywords"]', keywords);
  setMeta('meta[property="og:title"]', title);
  setMeta('meta[property="og:description"]', description);
  setMeta('meta[name="twitter:title"]', title);
  setMeta('meta[name="twitter:description"]', description);

  // Canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", `https://decorhub-ruddy.vercel.app${canonicalPath}`);
};

// ✅ Pre-defined SEO configs for each page
export const SEO_CONFIGS = {
  home: {
    title: "Best Event Decorators Near Me in Raipur, Chhattisgarh | DecorHub",
    description: "Find & book the best event decorators near you in Raipur, CG. Wedding, birthday, corporate decoration — compare prices & book instantly on DecorHub.",
    keywords: "best decorators near me, event decorators Raipur, wedding decorators Chhattisgarh, birthday decoration Raipur CG, decorator near me",
    canonicalPath: "/"
  },
  decorators: {
    title: "Top Event Decorators in Raipur Chhattisgarh | Book Now - DecorHub",
    description: "Browse 100+ verified event decorators in Raipur, Bilaspur, Durg, Bhilai CG. Read reviews, compare prices and book the best decorator for your event.",
    keywords: "decorators in Raipur, event decorators CG, wedding decorators near me, party decorators Chhattisgarh, best decorator Bilaspur Durg Bhilai",
    canonicalPath: "/decorators"
  },
  wedding: {
    title: "Best Wedding Decorators in Raipur Chhattisgarh | DecorHub CG",
    description: "Find the best wedding decorators in Raipur, CG. Beautiful mandap decoration, flower decoration, stage decoration & more. Book top wedding decorators on DecorHub.",
    keywords: "wedding decorators Raipur, wedding decoration Chhattisgarh, mandap decoration CG, best wedding decorator near me, shaadi decoration Raipur",
    canonicalPath: "/decorators?category=wedding"
  },
  birthday: {
    title: "Birthday Party Decorators Near Me in Raipur CG | DecorHub",
    description: "Book the best birthday party decorators in Raipur, Chhattisgarh. Balloon decoration, theme parties, surprise setups — find decorators near you on DecorHub.",
    keywords: "birthday decorators near me, birthday decoration Raipur, balloon decoration CG, theme birthday party decorator Chhattisgarh",
    canonicalPath: "/decorators?category=birthday"
  },
  corporate: {
    title: "Corporate Event Decorators in Raipur Chhattisgarh | DecorHub",
    description: "Professional corporate event decorators in Raipur, CG. Office parties, product launches, conferences — find & book corporate decorators on DecorHub.",
    keywords: "corporate event decorators Raipur, office decoration CG, corporate event planner Chhattisgarh, event management Raipur",
    canonicalPath: "/decorators?category=corporate"
  }
};
